import { useMutation, useQueryClient } from "@tanstack/react-query";

import axiosInstance from "@/api/axiosInstance";

const postAllReadNotify = async (category?: string) => {
  const response = await axiosInstance.post(
    "/api/v1/admin/notifications/read-all",
    {},
    { params: { category } }
  );
  return response.data;
};

export const usePostAllReadNotify = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ category }: { category?: string }) => postAllReadNotify(category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      queryClient.invalidateQueries({ queryKey: ["notificationUnreadCount"] });
    },
    onError: (error) => {
      console.error("usePostAllReadNotify error:", error);
    },
  });
};
